import { BaseService } from "@/servicesTs/base";
export class EpofService extends BaseService() {
    static get entity() {
        return "epof";
    }
    static get responseName() {
        return "epof";
    }
}
